import CommentsQuery from '~/graphql/queries/comments.graphql';

export const useCommentStore = defineStore('comment-store', () => {
    const comments = ref({});
    const pending = ref(false);

    const fetchComments = (videoId) => {
        pending.value = true;
        useNuxtApp().runWithContext(async() => {
            const { data: commentsData } = await useAsyncQuery({
                query: CommentsQuery,
                variables: {
                    videoId: videoId,
                },
                cachePolicy: 'network-only'
            });

            comments.value = commentsData.value?.comments;
        });
        pending.value = false;
    };

    return {
        comments,
        pending,
        fetchComments
    };
});
